"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.Text = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));
const Text = exports.Text = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  maxLines,
  isOverflowVisible
}) => ({
  ...(maxLines !== undefined ? {
    display: '-webkit-box',
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: 'vertical'
  } : {
    display: 'block'
  }),
  overflow: isOverflowVisible ? 'visible' : 'hidden',
  width: 'auto'
}));
const ToggleButton = exports.ToggleButton = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.default.main,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.text.hover,
    cursor: 'pointer'
  }
}));
//# sourceMappingURL=styles.js.map